const DEFAULT_ENDPOINT = '/api/theme/ad-placements';
const DEVICE_BREAKPOINTS = {
  mobile: 767,
  tablet: 1199
};

function configEndpoint() {
  return (
    window.WLA_AD_PLACEMENTS_ENDPOINT ||
    document.documentElement?.dataset?.wlaAdPlacementsEndpoint ||
    document.querySelector('meta[name="wla-ad-placements-endpoint"]')?.content ||
    DEFAULT_ENDPOINT
  );
}

function viewportDevice() {
  const width = window.innerWidth || document.documentElement.clientWidth || 0;
  if (width <= DEVICE_BREAKPOINTS.mobile) return 'mobile';
  if (width <= DEVICE_BREAKPOINTS.tablet) return 'tablet';
  return 'desktop';
}

function deviceMatches(rule) {
  const normalized = String(rule || 'all').trim();
  if (!normalized || normalized === 'all') return true;
  return normalized === viewportDevice();
}

function articleWordCount(card) {
  const article = card.closest('article') || document.querySelector('article');
  const text = article?.querySelector('.post-content, .post__content, .kg-canvas')?.textContent || article?.textContent || '';
  return text.trim().split(/\s+/).filter(Boolean).length;
}

function isActive(placement) {
  return placement?.status === 'active';
}

function placementCards(key) {
  const safeKey = window.CSS?.escape ? CSS.escape(key) : String(key).replace(/"/g, '\\"');
  return Array.from(document.querySelectorAll(`[data-wla-placement="${safeKey}"], [data-wla-ad-placement="${safeKey}"]`));
}

function hideCard(card, reason, fallback = 'hide') {
  card.dataset.wlaPlacementDisabled = reason;
  card.dataset.wlaPlacementFallback = fallback;
  if (fallback !== 'reserve') card.hidden = true;
}

function applyPlacementToCard(card, placement, defaultClient) {
  if (!isActive(placement)) {
    hideCard(card, 'inactive', placement.fallback);
    return;
  }

  if (!deviceMatches(placement.device)) {
    hideCard(card, 'device', placement.fallback);
    return;
  }

  if (Number(placement.minWords || 0) > articleWordCount(card)) {
    hideCard(card, 'min-words', placement.fallback);
    return;
  }

  const slot = card.querySelector('ins.adsbygoogle');
  if (slot) {
    const client = placement.client || defaultClient || slot.getAttribute('data-ad-client');
    if (client) slot.setAttribute('data-ad-client', client);
    if (placement.slot) slot.setAttribute('data-ad-slot', placement.slot);
  }

  card.hidden = false;
  card.dataset.wlaPlacementStatus = placement.status;
  card.dataset.wlaPlacementDevice = placement.device || 'all';
  card.dataset.wlaPlacementPosition = placement.position || '';
  card.dataset.wlaPlacementAutoTunable = placement.autoTunable ? 'true' : 'false';
}

function applyConfig(config) {
  const placements = Array.isArray(config?.placements) ? config.placements : [];
  placements.forEach((placement) => {
    if (!placement?.key) return;
    placementCards(placement.key).forEach((card) => applyPlacementToCard(card, placement, config.client));
  });

  window.dispatchEvent(new CustomEvent('wla-ad-placement-config-applied', { detail: { count: placements.length, config } }));
  return config;
}

export function initAdPlacementConfig() {
  const endpoint = configEndpoint();
  if (!endpoint) return Promise.resolve(null);

  return fetch(endpoint, { headers: { accept: 'application/json' }, credentials: 'omit' })
    .then((response) => (response.ok ? response.json() : null))
    .then((payload) => applyConfig(payload?.config || payload))
    .catch(() => null);
}
